export const UPDATE_HEADER_HEIGHT = "UPDATE_HEADER_HEIGHT"
export const UPDATE_IMPORTANT_MESSAGE_BAR_HEIGHT = "UPDATE_IMPORTANT_MESSAGE_BAR_HEIGHT"

export const initial_state = {
  header_height: 0,
  important_message_bar_height: 0,
}